
    import { Vue, Component, Watch } from 'vue-property-decorator'
    import { mapState } from 'vuex'
    import { Language } from '@/app/license/entities/language.entity'
    import moment from 'moment'

    @Component({
        computed: {
            ...mapState('license', ['license', 'languages']),
        }
    })
    export default class LanguageButton extends Vue {
        locale = this.$i18n.locale
        languages!: Language[]

        @Watch('locale')
        updateLocale(locale: string) {
            this.$i18n.locale = locale
            this.$vuetify.lang.current = locale
            moment.locale(locale)

            this.$store.dispatch('global/setLocale', locale)
        }

        flag(locale: string) {
            // eslint-disable-next-line import/no-dynamic-require,global-require
            return require(`../../../assets/flags/${locale}.svg`)
        }
    }
